import $ from 'jquery';

export const DROPDOWN_SETTINGS = {
  allowAdditions: false,
  fullTextSearch: true,
  message: {
    addResult: 'Ajouter <b>{term}</b>',
    count: '{count} sélections',
    maxSelections: '{maxCount} selections max',
    noResults: 'Pas de résultat.',
  },
};

export default function bind() {
  // Blur on card
  $('.special.card .image').dimmer({
    on: 'hover',
  });

  // Menu
  $('.ui.menu .ui.dropdown').dropdown({
    on: 'hover',
  });

  // Menu
  $('h1 .ui.dropdown').dropdown(DROPDOWN_SETTINGS);

  // Tabs
  $('.menu .item').tab();

  // Modal
  $('.ui.modal').modal({
    inverted: true,
    transition: 'fade',
  });

  // Checkbox
  $('.ui.checkbox').checkbox();
  $('.ui.checkbox.checked').checkbox('set checked');

  // Select
  $('.field .ui.dropdown').dropdown(DROPDOWN_SETTINGS);

  // Checkbox remove
  $('.ui.dropdown .remove.icon').on('click', clearDropdown);

  // OR buttons
  $('.inputOrButton .ui.button:last-child').on('click', evt => {
    const $button = $(evt.target);

    $button.toggleClass('states');
    $button.siblings('.ui.button').toggleClass('disabled');
  });
}

export const bootstrapUI = $scope => {
  $scope.find('.ui.dropdown').dropdown(DROPDOWN_SETTINGS);
  $scope.find('.ui.checkbox').checkbox();

  $scope.find('.ui.dropdown .remove.icon').on('click', clearDropdown);
};

function clearDropdown(evt) {
  evt.preventDefault();

  const $button = $(evt.target);
  const $dropdown = $button.closest('.dropdown');

  $dropdown.dropdown('clear');

  evt.stopPropagation();
}



// WEBPACK FOOTER //
// ./src/plugins/bootstrap.js